<script>

import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment.js';
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat.js';
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote.js';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold.js';
import Code from '@ckeditor/ckeditor5-basic-styles/src/code.js';
import CodeBlock from '@ckeditor/ckeditor5-code-block/src/codeblock.js';
import DataSchema from '@ckeditor/ckeditor5-html-support/src/dataschema.js';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials.js';
import FindAndReplace from '@ckeditor/ckeditor5-find-and-replace/src/findandreplace.js';
import FontBackgroundColor from '@ckeditor/ckeditor5-font/src/fontbackgroundcolor.js';
import FontColor from '@ckeditor/ckeditor5-font/src/fontcolor.js';
import FontFamily from '@ckeditor/ckeditor5-font/src/fontfamily.js';
import FontSize from '@ckeditor/ckeditor5-font/src/fontsize.js';
import GeneralHtmlSupport from '@ckeditor/ckeditor5-html-support/src/generalhtmlsupport.js';
import Heading from '@ckeditor/ckeditor5-heading/src/heading.js';
import Highlight from '@ckeditor/ckeditor5-highlight/src/highlight.js';
import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline.js';
import HtmlComment from '@ckeditor/ckeditor5-html-support/src/htmlcomment.js';
import HtmlEmbed from '@ckeditor/ckeditor5-html-embed/src/htmlembed.js';
import Image from '@ckeditor/ckeditor5-image/src/image.js';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption.js';
import ImageInsert from '@ckeditor/ckeditor5-image/src/imageinsert.js';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize.js';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle.js';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar.js';
// import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload.js';
import Indent from '@ckeditor/ckeditor5-indent/src/indent.js';
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock.js';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic.js';
import Link from '@ckeditor/ckeditor5-link/src/link.js';
import LinkImage from '@ckeditor/ckeditor5-link/src/linkimage.js';
import List from '@ckeditor/ckeditor5-list/src/list.js';
import ListStyle from '@ckeditor/ckeditor5-list/src/liststyle.js';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed.js';
// import MediaEmbedToolbar from '@ckeditor/ckeditor5-media-embed/src/mediaembedtoolbar.js';
import PageBreak from '@ckeditor/ckeditor5-page-break/src/pagebreak.js';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph.js';
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice.js';
import RemoveFormat from '@ckeditor/ckeditor5-remove-format/src/removeformat.js';
import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter.js';
import SourceEditing from '@ckeditor/ckeditor5-source-editing/src/sourceediting.js';
import SpecialCharacters from '@ckeditor/ckeditor5-special-characters/src/specialcharacters.js';
import SpecialCharactersArrows from '@ckeditor/ckeditor5-special-characters/src/specialcharactersarrows.js';
import SpecialCharactersCurrency from '@ckeditor/ckeditor5-special-characters/src/specialcharacterscurrency.js';
import SpecialCharactersEssentials from '@ckeditor/ckeditor5-special-characters/src/specialcharactersessentials.js';
import SpecialCharactersLatin from '@ckeditor/ckeditor5-special-characters/src/specialcharacterslatin.js';
import SpecialCharactersMathematical from '@ckeditor/ckeditor5-special-characters/src/specialcharactersmathematical.js';
import SpecialCharactersText from '@ckeditor/ckeditor5-special-characters/src/specialcharacterstext.js';
import Strikethrough from '@ckeditor/ckeditor5-basic-styles/src/strikethrough.js';
import Subscript from '@ckeditor/ckeditor5-basic-styles/src/subscript.js';
import Superscript from '@ckeditor/ckeditor5-basic-styles/src/superscript.js';
import Table from '@ckeditor/ckeditor5-table/src/table.js';
import TableCaption from '@ckeditor/ckeditor5-table/src/tablecaption.js';
import TableCellProperties from '@ckeditor/ckeditor5-table/src/tablecellproperties';
import TableProperties from '@ckeditor/ckeditor5-table/src/tableproperties';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar.js';
import TextTransformation from '@ckeditor/ckeditor5-typing/src/texttransformation.js';
import TodoList from '@ckeditor/ckeditor5-list/src/todolist';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline.js';
import WordCount from '@ckeditor/ckeditor5-word-count/src/wordcount.js';

export default {
  props: ['value'],
  components: { ckeditor: CKEditor.component },
  data() {
    return {
      editor: ClassicEditor,
      editorData: '<p>Content of the editor.</p>',
      editorConfig: {
        baseFloatZIndex: 5000,
				mediaEmbed: {
        	previewsInData: true
		    },
				plugins: [
					Alignment,
					Autoformat,
					BlockQuote,
					Bold,
					Code,
					CodeBlock,
					DataSchema,
					Essentials,
					FindAndReplace,
					FontBackgroundColor,
					FontColor,
					FontFamily,
					FontSize,
					GeneralHtmlSupport,
					Heading,
					Highlight,
					HorizontalLine,
					HtmlComment,
					HtmlEmbed,
					Image,
					ImageCaption,
					ImageInsert,
					ImageResize,
					ImageStyle,
					ImageToolbar,
					// ImageUpload,
					Indent,
					IndentBlock,
					Italic,
					Link,
					LinkImage,
					List,
					ListStyle,
					MediaEmbed,
					// MediaEmbedToolbar,
					PageBreak,
					Paragraph,
					PasteFromOffice,
					RemoveFormat,
					SimpleUploadAdapter,
					SourceEditing,
					SpecialCharacters,
					SpecialCharactersArrows,
					SpecialCharactersCurrency,
					SpecialCharactersEssentials,
					SpecialCharactersLatin,
					SpecialCharactersMathematical,
					SpecialCharactersText,
					Strikethrough,
					Subscript,
					Superscript,
					Table,
					TableCaption,
					TableCellProperties,
					TableProperties,
					TableToolbar,
					TextTransformation,
					TodoList,
					Underline,
					WordCount
				],
				toolbar: {
          shouldNotGroupWhenFull: true,
					items: [
						'undo',
						'redo',
						'findAndReplace',
						'|',
						'heading',
						'fontFamily',
						'fontSize',
						'fontColor',
						'fontBackgroundColor',
						'highlight',
						'bold',
						'underline',
						'italic',
						'bulletedList',
						'numberedList',
						'todoList',
						'blockQuote',
						'|',
						'alignment',
						'outdent',
						'indent',
						'|',
						'link',
						// 'imageUpload',
						'imageInsert',
						'mediaEmbed',
						'insertTable',
						'code',
						'codeBlock',
						'horizontalLine',
						'htmlEmbed',
						'pageBreak',
						'specialCharacters',
						'strikethrough',
						'subscript',
						'superscript',
						'sourceEditing',
						'removeFormat',
					]
				},
        fontSize: {
          options: [
            9,
            11,
            'default',
            15,
            17,
            19,
            21,
            23,
            25,
            30,
            35,
            40,
          ]
        },
				image: {
          resizeUnit: 'px',
					toolbar: [
						'imageTextAlternative',
						'imageStyle:inline',
						'imageStyle:block',
						'imageStyle:side',
						'linkImage'
					]
				},
				table: {
					contentToolbar: [
						'tableColumn',
						'tableRow',
						'mergeTableCells',
						'tableCellProperties',
						'tableProperties'
					]
				},
        fontColor: {
            colors: [
              { color: '#ffc425', label: 'Revinre yellow' },
              { color: '#37bd85', label: 'Green' },
              { color: '#666666', label: 'BG gray' },
              { color: '#ffffff', label: 'White', hasBorder: true },
              { color: '#000000', label: 'Black' },
              { color: '#3bafda', label: 'Baby blue' },
              { color: '#ff758e', label: 'Pink' },
              { color: '#6572b8', label: 'Purple' },
              { color: '#ff8a23', label: 'Orange' },
              { color: '#e0483c', label: 'Red' },
              { color: '#eeeeee ', label: 'Grayscale' },
              { color: '#bbbbbb ', label: 'Grayscale' },
              { color: '#999999 ', label: 'Grayscale' },
              { color: '#777777 ', label: 'Grayscale' },
              { color: '#444444 ', label: 'Grayscale' },
            ],
            // columns: 3,
        },
        fontBackgroundColor: {
          colors: [
            { color: '#ffc425', label: 'Revinre yellow' },
            { color: '#37bd85', label: 'Green' },
            { color: '#666666', label: 'BG gray' },
            { color: '#ffffff', label: 'White', hasBorder: true },
            { color: '#000000', label: 'Black' },
            { color: '#3bafda', label: 'Baby blue' },
            { color: '#ff758e', label: 'Pink' },
            { color: '#6572b8', label: 'Purple' },
            { color: '#ff8a23', label: 'Orange' },
            { color: '#e0483c', label: 'Red' },
            { color: '#eeeeee ', label: 'Grayscale' },
            { color: '#bbbbbb ', label: 'Grayscale' },
            { color: '#999999 ', label: 'Grayscale' },
            { color: '#777777 ', label: 'Grayscale' },
            { color: '#444444 ', label: 'Grayscale' },
          ],
          // columns: 6,
        },
      },
    }
  },
  watch: {

  },
  created() {

  },
  mounted() {
    // $('#ckeditorselector').closest('.modal').modal({
    //   focus: false
    // });
  },
  methods: {
		onReady(editor)  {
      editor.setData(this.value);
      editor.ui.getEditableElement().parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
      );
      editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        console.log(btoa(loader.file));
        return new UploadAdapter(loader);
      };
    },
    onEditorInput(content) {
      this.$emit("input", content);
    },

  }
}
</script>


<template>

  <div class="bg-white">
		<ckeditor id="ckeditorselector" :editor="editor" :config="editorConfig" @ready="onReady" @input="onEditorInput"></ckeditor>
  </div>

</template>

<style>
:root {
  --ck-z-default: 100;
  --ck-z-modal: calc( var(--ck-z-default) + 999 );
}
</style>
